// src/capacitorListeners.ts
import { App } from "@capacitor/app";
import { LiveUpdate } from "@capawesome/capacitor-live-update";
import { Capacitor } from "@capacitor/core";
import { Dialog } from "@capacitor/dialog";

async function askUserToReload(message: string): Promise<boolean> {
  if (Capacitor.isNativePlatform()) {
    const { value } = await Dialog.confirm({
      title: "Update available",
      message,
      okButtonTitle: "Install",
      cancelButtonTitle: "Later",
    });
    return value;
  }
  // Web/PWA fallback (not restricted by ESLint)
  return window.confirm(message);
}

export function registerResumeUpdateCheck() {
  App.addListener("resume", async () => {
    try {
      const { nextBundleId } = await LiveUpdate.sync();
      if (nextBundleId) {
        const shouldReload = await askUserToReload(
          "A new update is available. Install now?"
        );
        if (shouldReload) {
          await LiveUpdate.reload();
        }
      }
    } catch (e) {
      console.warn("Resume update check failed", e);
    }
  });
}
